import { Content } from 'Constants/styles';
import { useParams } from 'react-router-dom';

import Journal from './Journal';
import MerchantFailedPayouts from './MerchantFailedPayouts';
import Payouts from './Payouts/Payouts';

const MerchantPayouts = () => {
  const { merchantId } = useParams<{ merchantId: string; manage: string }>();

  return (
    <>
      <Content className="merchant-details-content">
        <Payouts merchantId={merchantId} />
        <MerchantFailedPayouts merchantId={merchantId} />
        <Journal merchantId={merchantId} />
      </Content>
    </>
  );
};

export default MerchantPayouts;
